module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-feinsteinzeug-gres-oro-venato-02.7e1d12ed.jpg";